import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Answer, Question } from '@haleo-frontend/data-access/models';
import * as moment from 'moment';
import { LanguageService } from '@haleo-frontend/data-access/services';

@Component({
    selector: 'haleo-picker-select-overlay',
    templateUrl: 'picker-select-overlay.component.html',
    styleUrls: ['picker-select-overlay.component.scss']
})
export class PickerSelectOverlayComponent implements OnInit {

    // Question: radio, number, numberRange, checkbox
    @Input() question: Question;
    @Input() answer: Answer | undefined;
    @Input() sleepWindow: any;
    column: { options: { text: string; value: number, duration?: any, transform?: any }[]; columnWidth: number; selectedIndex: number };
    states = {
        value: ''
    };

    constructor(private modalController: ModalController,
                private languageService: LanguageService) {
    }

    ngOnInit() {

        if (!this.question) {
            return;
        }

        let options;

        if (this.sleepWindow) {
            options = this.generateSleepWindowRange(this.sleepWindow);
        } else {
            options = this.generateByAnswerType();
        }

        this.column = {
            columnWidth: 200,
            options,
            selectedIndex: 0
        };

        let index = -1;
        const defaultValue = this.question.options ? JSON.parse(this.question.options)?.defaultValue : 0;

        if (defaultValue) {
            index = options.findIndex((option: any) => option.value == defaultValue);
        }

        if (this.answer && this.answer.value) {
            index = options.findIndex((option: any) => option.value == this.answer?.value);
        }

        if (index > 0) {
            this.column.selectedIndex = index;
        }

        if (this.sleepWindow) {
            this.column.selectedIndex = Math.round(options.length / 2);
        }
    }

    onChangeSelect(value: any) {
        this.states.value = value;
    }

    async close() {
        await this.modalController.dismiss({questionKey: this.question.key, value: this.states.value});
    }

    async cancel() {
        await this.modalController.dismiss();
    }

    private generateByAnswerType() {

        const options = JSON.parse(this.question.options);

        if (this.question.answerType === 'radio') {
            return Object.keys(options).map((key: any) => {
                return {
                    value: parseInt(key),
                    text: options[key]
                };
            });
        }

        return this.generateByRange(options.min, options.max, options?.interval, options?.unit);
    }

    private generateByRange(lower: number, upper: number, interval = 1, unit = '') {

        const options = [];
        for (let i = Number(lower); i <= Number(upper);) {

            options.push({
                value: i,
                text: i + (unit ? ` ${unit}` : '')
            });

            i += interval ? Number(interval) : 1;
        }
        return options;
    }

    private generateSleepWindowRange(sleepWindow: any) {

        const {min, max, interval} = sleepWindow;
        const options = [];

        for (let i = Number(min); i <= Number(max);) {

            options.push({
                value: i,
                text: this.getTextBySleepWindowType(sleepWindow, i)
            });

            i += interval ? Number(interval) : 1;
        }

        return options;
    }

    private getTextBySleepWindowType(sleepWindow: any, index: number) {

        const locale = this.languageService.locale;
        const {bedTime, riseTime} = sleepWindow;

        const start = moment(bedTime, 'HH:mm').add(index, 'minutes').format(locale === 'fr-ca' ? 'HH:mm' : 'hh:mm a');
        const end = moment(riseTime, 'HH:mm').add(index, 'minutes').format(locale === 'fr-ca' ? 'HH:mm' : 'hh:mm a');

        if (sleepWindow?.type === 'riseTime') {
            return end;
        } else if (sleepWindow?.type === 'bedTime') {
            return start;
        } else {
            return start + ' - ' + end;
        }
    }
}
